import React from "react";
import imgURL from "../../assets/images/image_pi.png";

const Card = (props) => {
  const { color, height } = props;
  return (
    <>
      {/* <div className={`h-${height} bg-[${color}] rounded-md`} > */}
      <div className="hs-[28vh] h-full mds:h-[45vh] lgs:h-[55vh] xl:min-h-[55vh] bg-[#101942] rounded-md flex flex-col justify-center ">
        <img
          src={imgURL}
          // className="w-[70%] md:w-[100%] m-auto h-full object-contain"
          className="w-[70%] md:w-[50%] m-auto h-[60%] md:h-full object-contain"
          alt="pi-image"
        />
      </div>
    </>
  );
};

export default Card;
